module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/bg_01-920ad123a24cd8540e24d759b09f5524.jpg";